module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips-mask"
  }, [_c('div', {
    staticClass: "tips-auto-wrapper"
  }, [_c('div', {
    staticClass: "tips-auto-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.tipsFont))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e83311c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipsAuto.vue
// module id = 624
// module chunks = 1